// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DialogController from "./dialog_controller.js"
application.register("dialog", DialogController)

import DialogInlineController from "./dialog_inline_controller.js"
application.register("dialog-inline", DialogInlineController)

import PagyInitializerController from "./pagy_initializer_controller.js"
application.register("pagy-initializer", PagyInitializerController)

import StripeController from "./stripe_controller.js"
application.register("stripe", StripeController)

import MapController from "./map_controller.js"
application.register("map", MapController)
